import React from 'react';
import { Column } from 'react-table';

import { TableComponent, Button } from '../../../../../shared/Components';
import { FlexContainer, Image } from '../../../../../shared/Typhography';
import { strings } from '../../../../../strings';
import { FileData } from '../CreatePuzzleScreen';

interface Data extends FileData {
  action?: () => void;
}

interface Props {
  dataTable: Data[];
  editPuzzle: (image: Data) => void;
  removePuzzle: (id: string) => void;
}

const AcceptedFilesTable = ({ dataTable, editPuzzle, removePuzzle }: Props) => {
  const data = React.useMemo(() => {
    return dataTable?.map((item: any) => ({
      url: item.url,
      name: item.name,
      id: item.id,
      keywords: item.keywords,
      collection: item.collection,
      collectionIds: item.collectionIds,
      type: item.type,
    }));
  }, [dataTable]);

  const headers: Column<Data>[] = React.useMemo(
    () => [
      {
        Header: strings.image,
        accessor: 'url',
        Cell: (cell) => (
          <Image size="tableImage" borderRadiusType="rounded" src={cell.row.original.url} />
        ),
      },
      {
        Header: strings.name,
        accessor: 'name',
      },
      {
        Header: strings.placeholderKeywords,
        accessor: 'keywords',
      },
      {
        Header: strings.navCreateCollectionTab,
        accessor: 'collection',
      },
      {
        Header: strings.action,
        accessor: 'action',
        Cell: (cell) => (
          <FlexContainer gap="1rem">
            <Button variant="link" onClick={() => editPuzzle(cell.row.original)}>
              {strings.edit}
            </Button>
            <Button
              variant="danger"
              width={100}
              height={40}
              onClick={() => removePuzzle(cell.row.original.id)}
            >
              {strings.delete}
            </Button>
          </FlexContainer>
        ),
      },
    ],
    [dataTable],
  );

  return <TableComponent columns={headers} data={data} />;
};

export default AcceptedFilesTable;
